import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const SleepStudy = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id="clpAndCnpTests.sleepStudy" />}
      newButton={
        <DocumentCreationButton
          name="sleepStudy"
          text="clpAndCnpTests.newSleepStudy"
          onClick={startEdit({}, 'sleepStudy')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={10}></Item>
          </>
        }
        contentFormat={(d): React.JSX.Element => (
          <>
            <Item xs={2} style={{ fontWeight: 600 }}>
              {formatPartialDate(d.date ?? undefined)}
            </Item>
            <Item xs={7}></Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} view={view} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'sleepStudy'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default SleepStudy;
